/* src/app/components/shop/products/product-no-sidebar/product-no-sidebar.component.scss */
#product-no-sidebar {
  background-color: #EBEBEB;
}
#product-no-sidebar .main {
  max-width: 1265px;
  margin: auto;
}
@media only screen and (max-width: 1200px) {
  #product-no-sidebar .main {
    margin: 0px 33px;
  }
}
@media only screen and (max-width: 992px) {
  #product-no-sidebar .main {
    margin: 0px 68px;
  }
}
@media only screen and (max-width: 600px) {
  #product-no-sidebar .main {
    margin: 0px 0px;
  }
}
#product-no-sidebar .main .firstContainer {
  margin: 27px 20px 0px 0px;
}
#product-no-sidebar .main .firstContainer .checkBox {
  align-items: center;
  min-height: 48px;
  height: auto;
}
#product-no-sidebar .main .secondContainer .sortBy {
  background-color: white;
  width: 140px;
  height: 25px;
}
@media only screen and (max-width: 600px) {
  #product-no-sidebar .main .secondContainer .m-left-33 {
    margin: 0px 30px;
  }
}
@media only screen and (min-width: 1200px) {
  #product-no-sidebar .main .secondContainer .m-right-20 {
    margin-right: 20px;
  }
}
#product-no-sidebar .color1-f-s-17 {
  color: #000000;
  font-size: 17px;
  margin-bottom: 15px !important;
  font-weight: 700;
}
#product-no-sidebar .borderBottom {
  border-bottom: 1px solid #cfcfcf;
}
#product-no-sidebar .color1-f-s-14 {
  color: #000000;
  font-size: 14px;
  padding-right: 5px;
}
#product-no-sidebar .color2-f-s-14 {
  color: #000000;
  font-size: 14px;
  padding-right: 5px;
  font-weight: bold;
}
#product-no-sidebar .color1-f-s-13 {
  font-size: 13px !important;
  color: #5E5E5E !important;
  font-family: roboto !important;
  font-weight: bold;
}
#product-no-sidebar .color1-f-s-12 {
  font-size: 12px;
  color: #777777;
  font-family: roboto;
}
#product-no-sidebar .m-l-r-8 {
  margin: 0px 8px;
}
.prouduct {
  font-family: "IBM Plex Sans", sans-serif !important;
  background-color: white !important;
}
.prouduct .bg-white-smoke {
  background-color: rgb(240, 240, 240);
}
.prouduct .w-72 {
  width: 72%;
}
.prouduct .p-relative {
  position: relative !important;
}
.prouduct .p-absolute {
  position: absolute !important;
}
.prouduct .img-bg {
  flex: none !important;
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 450px;
}
.prouduct .m-t-40 {
  margin-top: 40px !important;
}
.prouduct .abs-width {
  width: 100%;
  left: 5%;
}
.prouduct .shop-btn {
  background: var(--theme-deafult-secondary);
  border-radius: 23px;
  display: inline-block;
  padding: 15px 32px;
  cursor: pointer;
}
.prouduct .shop-btn:hover {
  background-color: var(--theme-deafult-secondary);
}
.prouduct .product-button {
  margin: 20px;
  padding: 6px 32px !important;
  background-color: black !important;
  color: white !important;
}
.prouduct .product-button:hover {
  background-color: #333333 !important;
}
.prouduct .d-none {
  opacity: 0;
}
.prouduct .w-89 {
  width: 89%;
}
.prouduct .text-end {
  text-align: end;
}
.prouduct .sale {
  padding: 10px 17px;
  background-color: #CF2929;
  border-radius: 23px;
  display: inline;
  color: white;
}
.prouduct .justify-content {
  justify-content: space-between !important;
}
.prouduct .bg-img img {
  width: 100%;
  height: 437px;
  object-fit: cover;
  object-position: top;
}
.prouduct .p-abs {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.prouduct .p-content-div {
  top: 30%;
}
.prouduct .w-35 {
  width: 35%;
}
.prouduct .faded-in {
  animation: fadeIn 0.6s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.prouduct .faded-out {
  animation: fadeOut 0.6s;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(16px);
  }
}
@media (min-width: 0px) and (max-width: 960px) {
  .prouduct .img-bg {
    height: 320px !important;
  }
  .prouduct .d-none {
    opacity: 1 !important;
  }
}
.prouduct .design ::ng-deep .mat-mdc-input-element {
  vertical-align: text-top !important;
}
/*# sourceMappingURL=product-no-sidebar.component.css.map */
